import { client } from "./api/client.gen";

export function configureAppApi(config: { baseUrl: string }) {
  client.setConfig(config);
}
